import { SupportTip } from '@pu/models';

export interface GetTipsRes {
  itemsCount: number;
  tips: SupportTip[];
}
